export {
  useMetaSDK,
  launchWhatsAppEmbeddedSignup,
  launchMessengerLogin,
  launchInstagramLogin,
  type EmbeddedSignupResult,
  type MetaLoginResult,
} from "./useMetaSDK";

import { useMetaSDK } from "./useMetaSDK";

/** @deprecated Use useMetaSDK instead */
export const useFacebookSDK = () => {
  const { sdkReady, launchWhatsAppEmbeddedSignup } = useMetaSDK();
  return {
    sdkReady,
    launchEmbeddedSignup: launchWhatsAppEmbeddedSignup,
  };
};
